import React from 'react'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useHistory } from 'react-router-dom'
import useSubmitTask from 'hooks/useSubmitTask'

import { zodResolver } from '@hookform/resolvers/zod'
import { FormProvider, useForm } from 'react-hook-form'
import { RefuseRequestTaskSchema } from './RefuseRequestTaskSchema'
import HFTextInput from 'components/HFInputs/HFTextInput'
import TaskHeaderErrors from 'components/TaskHeaderErrors/TaskHeaderErrors'
import FinalizeTaskDialog from '../../FinalizeTaskController/FinalizeTaskDialog'

import styles from '../../Dialog.module.sass'

const RefuseRequestTaskController = (props) => {
	const { i18n } = useGlobal()
	const { data, resolve, dismiss, id } = props
	const history = useHistory()

	const methods = useForm({
		mode: 'onSubmit',
		resolver: zodResolver(RefuseRequestTaskSchema),
		shouldUnregister: true,
	})
	const { handleSubmit, formState } = methods

	const { error, submitting, refuseRequestTask } = useSubmitTask(
		data?.id,
		formState?.errors
	)

	const onSubmit = (formData) => {
		const body = {
			...formData,
			processId: data.processId,
			processRequestId: data.processRequest.processRequestId,
			type: data.type,
		}

		refuseRequestTask(body)
			.then(() => {
				resolve()
			})
			.catch(() => {})
	}

	return (
		<>
			<TaskHeaderErrors errors={error ?? []} />
			{submitting && (
				<FinalizeTaskDialog
					dismiss={dismiss}
					submitting={submitting}
					task={data}
					submissionType='refuse'
				/>
			)}
			<FormProvider {...methods}>
				<div className={styles['form-container']}>
					<form
						id={`form_refuse_${id}`}
						className={styles['form']}
						onSubmit={handleSubmit(onSubmit)}
					>
						<h4
							className={`${styles['form-title']}`}
						>{i18n`Refuse requisition`}</h4>
						<fieldset>
							<h5
								className={styles['input-title']}
							>{i18n`Refusal reason`}</h5>
							<HFTextInput
								name='justification'
								placeholder={i18n`Justification`}
								multiline={true}
								rows={5}
								noResize
							/>
						</fieldset>
					</form>
				</div>
			</FormProvider>
			<menu className={styles['menu']}>
				<ActionButton
					key='cancel'
					secondary={true}
					className={styles['menu-button-secondary']}
					onClick={() => {
						history.goBack()
					}}
				>
					{i18n`Cancel`}
				</ActionButton>
				<ActionButton
					className={styles['menu-button-primary-refuse']}
					form={`form_refuse_${id}`}
				>
					{i18n`Refuse`}
				</ActionButton>
			</menu>
		</>
	)
}

export default RefuseRequestTaskController
